import React, { Component }  from 'react';
import _ from 'lodash';
import Emitter from './Emitter';
import { CheckDeviceSupport } from './CheckMedia';

//import PropTypes from "prop-types";

/**
 * Manage all media devices
 */
class MediaDevice extends Emitter {

  constructor(props) {
    super(props);
    this.state =  {
      hasWebcam: false,
      hasMicrophone: false,
      isMicrophoneAlreadyCaptured: false,
      isWebcamAlreadyCaptured: false,
    };



  }

  /**
   * Start media devices and send stream
   */
  async start() {


    
    var res = await CheckDeviceSupport(( function(res) {
                //console.log('hasWebCam: '+ res.hasWebcam);
                //console.log('hasMicrophone: '+ res.hasMicrophone);
                //console.log('isMicrophoneAlreadyCaptured: '+ res.isMicrophoneAlreadyCaptured);
                //console.log('isWebcamAlreadyCaptured: '+ res.isWebcamAlreadyCaptured);
                          
            
              }.bind(this)));
    

    //console.log(res);
    


    const constraints = {
      video: {
        facingMode: 'user',
        height: { min: 360, ideal: 720, max: 1080 }
      },
      audio: true
    };
    // check for microphone/camera support!
    

    if(navigator.mediaDevices == null){
      alert('Cannot open webcam and/or microphone');
      return this;
    }

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        this.stream = stream;
        this.emit('stream', stream);
      })
      .catch((err) => {
        if (err instanceof DOMException) {
          alert('Cannot open webcam and/or microphone');
        } else {
          // console.log(err);
        }
      });

    return this;
  }

  /**
   * Turn on/off a device
   * @param {String} type - Type of the device
   * @param {Boolean} [on] - State of the device
   */
  toggle(type, on) {
    const len = arguments.length;
    if (this.stream) {
      this.stream[`get${type}Tracks`]().forEach((track) => {
        const state = len === 2 ? on : !track.enabled;
        _.set(track, 'enabled', state);
      });
    }
    return this;
  }

  /**
   * Stop all media track of devices
   */
  stop() {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
    }
    return this;
  }
}

export default MediaDevice;
